export function buildAtomicBookingDispositions({
  baseDispositions = [],
  planVisitBookings,
  postOpDecisions,
} = {}) {
  const out = [...baseDispositions];

  for (const booking of planVisitBookings?.values?.() || []) {
    if (!booking?.appointment_id) continue;
    out.push({
      kind: "book_plan_visits",
      appointment_id: booking.appointment_id,
      procedure_visit_ids: (booking.visit_ids || []).filter(Boolean),
    });
  }

  for (const decision of Object.values(postOpDecisions || {})) {
    if (decision?.kind === "book") {
      if (!decision.appointment_id) continue;
      if (!decision.source_procedure_visit_id && !decision.source_item_key) continue;
      out.push({
        kind: "book_post_op_followup",
        appointment_id: decision.appointment_id,
        source_procedure_visit_id: decision.source_procedure_visit_id || undefined,
        source_item_key: decision.source_item_key || undefined,
        source_procedure_name: decision.source_procedure_name || undefined,
        source_tooth_number: decision.source_tooth_number || undefined,
        followup_procedure_id: decision.followup_procedure_id || undefined,
        follow_up_after_days: decision.follow_up_after_days || undefined,
      });
      continue;
    }

    if (decision?.kind === "unsure" && decision.source_item_key && !decision.source_procedure_visit_id) {
      out.push({
        kind: "queue_post_op_followup",
        source_item_key: decision.source_item_key,
        source_procedure_name: decision.source_procedure_name || undefined,
        source_tooth_number: decision.source_tooth_number || undefined,
        followup_procedure_id: decision.followup_procedure_id || undefined,
        follow_up_after_days: decision.follow_up_after_days || undefined,
      });
    }
  }

  return out;
}
